import { UserRights } from '@work4all/models/lib/additionalEnums/UserRights';
import { ModuleAccessRightType } from '@work4all/models/lib/Enums/ModuleAccessRightType.enum';

export enum StatisticType {
  dashboard = 'dashboard',
  salesvolumeyear = 'salesvolumeyear',
  salesvolumebycustomer = 'salesvolumebycustomer',
  salesvolumebycostcenter = 'salesvolumebycostcenter',
  salesvolumebyitem = 'salesvolumebyitem',
  customersheet = 'customersheet',
  timecard = 'timecard',
  companyreport = 'companyreport',
  suppliersheet = 'suppliersheet',
  erp = 'erp',
  hr = 'hr',
  common = 'common',
  salesvolumebysupplier = 'salesvolumebysupplier',
}

export interface StatisticDefinitionItem {
  title: string;
  statisticType?: StatisticType;
  anyOfRights?: UserRights[];
  needsModule?: ModuleAccessRightType;
  children?: StatisticDefinitionItem[];
}

export const statisticDefinitions: StatisticDefinitionItem[] = [
  {
    title: 'common',
    statisticType: StatisticType.common,
    children: [
      {
        title: 'dashboard',
        statisticType: StatisticType.dashboard,
        needsModule: ModuleAccessRightType.FEATURE_STATISTICS,
      },
      {
        title: 'timecard',
        statisticType: StatisticType.timecard,
        needsModule: ModuleAccessRightType.FEATURE_WORK_TIME_TRACKING,
        anyOfRights: [
          UserRights.Zeitkarte_Alle,
          UserRights.Zeitkarte_AnsichtEigene,
          UserRights.Zeitkarte_AnsichtEigeneUndZugeordneteMitarbeiter,
        ],
      },
    ],
  },
  {
    title: 'erp',
    statisticType: StatisticType.erp,
    needsModule: ModuleAccessRightType.FEATURE_STATISTICS,
    children: [
      {
        title: 'salesvolumebycustomer',
        statisticType: StatisticType.salesvolumebycustomer,
        needsModule: ModuleAccessRightType.FEATURE_STATISTICS,
      },
      {
        title: 'salesvolumebycostcenter',
        statisticType: StatisticType.salesvolumebycostcenter,
        needsModule: ModuleAccessRightType.FEATURE_STATISTICS,
      },
      {
        title: 'salesvolumebyitem',
        statisticType: StatisticType.salesvolumebyitem,
        needsModule: ModuleAccessRightType.FEATURE_STATISTICS,
      },
      {
        title: 'salesvolumebysupplier',
        statisticType: StatisticType.salesvolumebysupplier,
        needsModule: ModuleAccessRightType.FEATURE_STATISTICS,
      },
      {
        title: 'salesvolumeyear',
        statisticType: StatisticType.salesvolumeyear,
        needsModule: ModuleAccessRightType.FEATURE_STATISTICS,
      },
      {
        title: 'customersheet',
        statisticType: StatisticType.customersheet,
        needsModule: ModuleAccessRightType.FEATURE_STATISTICS,
      },
      {
        title: 'suppliersheet',
        statisticType: StatisticType.suppliersheet,
        needsModule: ModuleAccessRightType.FEATURE_STATISTICS,
      },
    ],
  },
];

export const getStatisticDefByStatisticType = (
  type: StatisticType,
  parent: StatisticDefinitionItem = null,
  definitions: StatisticDefinitionItem[] = statisticDefinitions
): { parent: StatisticDefinitionItem; item: StatisticDefinitionItem } => {
  let result: {
    parent: StatisticDefinitionItem;
    item: StatisticDefinitionItem;
  } = null;
  definitions.some((x) => {
    if (x.statisticType === type) {
      result = { parent, item: x };
      return true;
    }
    if (!result && x.children) {
      result = getStatisticDefByStatisticType(type, x, x.children);
    }
  });

  return result;
};
